import { useState } from "react";
import SchoolLogo from "./SchoolLogo";
import { useNavigate } from "react-router-dom";
import { TextInput } from "../../../components";
import StudentsTable from "./StudentsTable";
import { useSelector } from "react-redux";

const RegisteredStudents = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { userDetails: schoolDetails } = useSelector((state) => state.auth);
  const { participants, loading } = useSelector(
    (state) => state.schoolParticipants
  );

  return (
    <div className="registered-students-container container space-y-5">
      <div className="flex items-center justify-center p-4">
        <SchoolLogo schoolDetails={schoolDetails} />
      </div>
      <div className="flex justify-between items-md-center flex-column flex-md-row">
        <div>
          <h2 className="text-3xl font-bold">Registered Students</h2>
          <p className="text-base font-medium mb-2">
            Academic Year {"2024 - 25"}
          </p>
        </div>
        <div className="d-block d-md-flex items-center gap-2">
          <TextInput
            placeholderText="Search Students"
            inputName="search"
            type="search"
            handleChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="pb-10">
        {loading ? (
          <div className="text-center my-10">
            <h1 className="text-3xl font-bold text-gray-500">Loading</h1>
          </div>
        ) : participants.length ? (
          <StudentsTable students={participants} searchQuery={searchQuery} />
        ) : (
          <div className="text-center my-10">
            <h1 className="text-3xl font-bold text-gray-500">
              No Participants Registered
            </h1>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisteredStudents;
